import { apiCall } from "../../components/service/api-service";

 //List
 export const getAnnouncementListApi = async (params) => {
  return apiCall("GET", `enquiry${params}`);
};

//Save
export const createAnnouncementApi = async (data) => {
  return apiCall("POST", "enquiry", data);
};

//Update
export const UpdateAnnouncementApi = async (data, id) => {
  return apiCall("PUT", `enquiry/${id}`, data);
};

//Edit
export const getAnnouncementDetailsApi = async (id) => {
  const response = await apiCall("GET", `enquiry/edit/${id}`);
  return response.data;
};

//View
 export const getAnnouncementData = async (id) => {
  const response = await apiCall("GET", `enquiry/view/${id}`);
  return response.data;
};

//Service 
export const getServiceListApi = async (params) => { 
  return apiCall("GET", `get_services${params}`);
};





 
 

